import React, { useState } from "react";
import { push } from "react-router-redux";
import PropTypes from "prop-types";
import { get } from "lodash";
import api from "APP_ROOT/api";
import {
  useCurrentUser,
  useDispatch,
  useScrollToOnMount
} from "APP_ROOT/hooks";
import { Errors, Form as AppForm } from "MODULES/shared/components/Forms";
import * as actions from "MODULES/PurchaseOrders/actions";
import Form from "MODULES/PurchaseOrders/components/Detail/LineItemsTable/Form";
import {
  ID,
  SERVICEABLE_TOOLING,
  SHIPPING_TYPE,
  UUID
} from "APP_ROOT/constants";
import { LLP } from "MODULES/parts/constants";
import styles from "../../styles";

export default function CreateLineItem({ close, part, purchaseOrder }) {
  const scrollToRef = useScrollToOnMount();
  const currentUser = useCurrentUser();
  const { onSubmit, onCancel, setSubmittedWith } = useOnSubmit(
    purchaseOrder,
    close
  );
  const lineItem = part && {
    part,
    part_id: part.id,
    dom_sensitive: part.dom_sensitive
  };
  const [selectedPart, setSelectedPart] = useState({});
  const domLifeYears = get(part, "dom_life_years");
  const llp = get(part, LLP);

  return (
    <div
      className="panel panel-default"
      style={styles.container}
      ref={scrollToRef}
    >
      <div className="panel-body">
        <button className="close" type="button" onClick={close}>
          <span>
            <i className="fa fa-close" />
          </span>
        </button>
        <h4 className="modal-title" style={styles.title}>
          Add Part to Purchase Order
        </h4>
        <Form
          close={close}
          initialValues={initialValues(lineItem, currentUser, purchaseOrder)}
          selectedPart={selectedPart}
          setSelectedPart={setSelectedPart}
          showBuyers={false}
          domLifeYears={domLifeYears}
          llp={llp}
          lineItem={lineItem}
          id={purchaseOrder.get(ID)}
          shippingType={purchaseOrder.get(SHIPPING_TYPE)}
          onSubmit={onSubmit}
          modalMode={false}
          renderFooter={formProps => (
            <AppForm.Footer>
              {formProps.submitFailed && (
                <Errors errors={formProps.errorMessages} />
              )}
              <AppForm.Cancel close={onCancel} editable />
              <AppForm.Submit
                disabled={false}
                editable
                submitting={formProps.submitting}
                onClick={() => setSubmittedWith("save")}
              />
              <AppForm.Submit
                disabled={false}
                editable
                submitting={formProps.submitting}
                text="Save and Go To PO"
                onClick={() => setSubmittedWith("save-and-go")}
              />
            </AppForm.Footer>
          )}
        />
      </div>
    </div>
  );
}

CreateLineItem.propTypes = {
  close: PropTypes.func.isRequired,
  part: PropTypes.shape({}),
  purchaseOrder: PropTypes.shape({})
};

// TODO: The code below is a direct copy of AddPart.jsx. Need to figure out a way to share form initialization!
function initialValues(lineItem, currentUser, purchaseOrder) {
  const values = {
    buyer_credit_pct: 75,
    condition: get(lineItem, "part.tooling_part_type")
      ? SERVICEABLE_TOOLING
      : undefined,
    request_vendor_approval: false,
    request_shop_approval: false,
    same_as_billing: true,
    evaluation_period: 30,
    reserve_for_seller_id: currentUser.id,
    read_only_buyer: purchaseOrder.getIn(["buyer", "full_name"]),
    insurance_type: "None",
    cancelled: false,
    part: {
      pass_fail: get(lineItem, "part.pass_fail")
    },
    purchase_for_sale: false,
    purchase_for_stock: false,
    purchase_for_repair: false,
    purchase_for_repair_assist: false,
    quantity: get(lineItem, "part.dom_sensitive") ? 1 : undefined,
    tagged_by: undefined,
    tagged_by_id: undefined,
    tagged_by_hold: false
  };

  if (!purchaseOrder.get("buyers_discrepancy")) {
    values.buyer_credit_pct = purchaseOrder.get("buyer_credit_pct");
    values.co_buyer_id = purchaseOrder.get("co_buyer_id");
    values.third_buyer_id = purchaseOrder.get("third_buyer_id");
    if (lineItem) {
      lineItem.co_buyer =
        purchaseOrder.get("co_buyer") && purchaseOrder.get("co_buyer").toJS();
      lineItem.third_buyer =
        purchaseOrder.get("third_buyer") &&
        purchaseOrder.get("third_buyer").toJS();
    }
  }

  return values;
}

// Custom hooks
function useOnSubmit(purchaseOrder, close) {
  const dispatch = useDispatch();
  const [submittedWith, setSubmittedWith] = useState(null);

  const onCancel = () => {
    close();
    api.purchaseOrders.cancel(purchaseOrder.get(ID), "cancelled_by_tenant");
  };

  const onSubmit = data =>
    dispatch(
      actions.addLineItem(data, purchaseOrder.get(ID), () => {
        if (submittedWith === "save-and-go") {
          dispatch(
            push({ pathname: `/purchase-orders/${purchaseOrder.get(UUID)}` })
          );
        } else {
          window.scrollTo(0, 0);
          close();
        }
      })
    );

  return {
    onSubmit,
    onCancel,
    setSubmittedWith
  };
}



// WEBPACK FOOTER //
// ./app/modules/parts/components/Detail/PurchaseOrders/Create/CreateLineItem.jsx